<template>
	<div class="home">
		<!-- 导航栏 -->
		<div class="nav-wrapper">
			<nav class="navbar" style="background-color: #002e70;">
				<div class="nav-container">
					<!-- 左侧图标 -->
					<div class="nav-logo logo-left">
						<img :src="$homePageInfo['fileDomain']+$homePageInfo[$homePageInfo['dataSourceType'] + ':website_setting:website_logo']" alt="Logo"
							style="height: 90px;">
					</div>

					<!-- 右侧导航菜单 -->
					<div class="nav-menu">
						<ul class="main-menu">
							<li v-for="(menu,index) in websiteMenuList" :key="index" :class="{ 'active': true,'has-submenu': menu.children.length>1}"
							@mouseenter="openSubmenu(menu.routeName,index)" @mouseleave="closeSubmenu"
							>
								<a @click="toRoute(index,menu.path)">{{menu.menuName}}</a>
								<div :class="{'active-line':nowIndex ==index}"></div>
								<ul :class="{'submenu':true,'display-none':nowSubIndex !== index}" v-if="menu.children.length>1">
									<li v-for="(subMenu,subIndex) in menu.children" :key="subIndex" 
									:class="{'disabled-menu-item':subMenu.status==1,'has-submenu':subMenu.children.length>1}" 
									 @mouseenter="openThirdMenu(subMenu.routeName,subIndex)" @mouseleave="closeThirdMenu">
										<ul :class="{'third-menu':subMenu.children.length>1,'display-none':nowThirdIndex !== subIndex}">
											<li v-for="(thirdMenu,thirdIndex) in subMenu.children" :key="thirdIndex" :class="{'disabled-menu-item':thirdMenu.status==1}" >
												<a :href="thirdMenu.path" target="_blank" v-if="thirdMenu.isFrame==0" :class="{'disabled-link':thirdMenu.status==1}">{{thirdMenu.menuName}}</a>
												<a @click="toRouteNoIndex(thirdMenu.path)" v-if="thirdMenu.isFrame==1" :class="{'disabled-link':thirdMenu.status==1}">{{thirdMenu.menuName}}</a>
											</li>
										</ul>
										<a :href="subMenu.path" target="_blank" v-if="subMenu.isFrame==0" :class="{'disabled-link':subMenu.status==1}">{{subMenu.menuName}}</a>
										<a @click="toRouteNoIndex(subMenu.path)" v-if="subMenu.isFrame==1" :class="{'disabled-link':subMenu.status==1}">{{subMenu.menuName}}</a>
									</li>
								</ul>
							</li>
							
						</ul>
					</div>
					
					<!-- 新增右上角登录注册区域 -->
					<!-- <div class="top-right-auth">
						<a href="https://sso.mdslyun.com/Acount/Login" target="_blank">登录</a>
						<span class="auth-divider">|</span>
						<a href="https://sso.yamdyun.com/" target="_blank">注册</a>
					</div> -->

				</div>
			</nav>
		</div>
	</div>
</template>

<script>
	import {
		getWebsiteMenus
	} from "@/api/home"

	export default {
		name: 'navBar',
		data() {
			return {
				activeMenu: 'Home',
				activeThirdMenu: null,
				websiteMenuList: [],
				nowIndex:0,
				nowSubIndex:-1,
				nowThirdIndex:-1,
			}
		},
		created() {
			getWebsiteMenus().then(res => {
				this.websiteMenuList = res.data
			})
		},
		methods: {
			isActive(path) {
				return this.$route.path === path
			},
			openSubmenu(menu,index) {
				this.activeMenu = menu
				this.nowSubIndex = index
			},
			closeSubmenu() {
				this.activeMenu = null
				this.activeThirdMenu = null
				this.nowSubIndex = -1
			},
			openThirdMenu(menu,index) {
				this.activeThirdMenu = menu
				this.nowThirdIndex = index
			},
			closeThirdMenu() {
				this.activeThirdMenu = null
				this.nowThirdIndex = -1
			},
			toRoute(index,name) {
				if (name&&this.$route.name !== name) {
					this.nowIndex = index
					this.$router.push({
						name
					})
				}
				this.closeSubmenu()
			},
			toRouteNoIndex(name) {
				if (name&&this.$route.name !== name) {
					this.$router.push({
						name
					})
				}
				this.closeSubmenu()
			}
		}
	}
</script>

<style scoped>
	/* 导航栏容器 */
	.nav-wrapper {
		width: 100%;
		margin: 0;
		padding: 0;
	}

	/* Logo靠左 */
	.logo-left {
		margin-left: 20px;
	}

	/* 导航栏基础样式 */
	.navbar {
		height: 90px;
		color: white;
		display: flex;
		align-items: center;
		padding: 0;
		margin: 0;
	}

	.nav-container {
		width: 100%;
		max-width: 1200px;
		margin: 0 auto;
		display: flex;
		align-items: center;
	}

	.nav-logo {
		margin-right: 40px;
	}

	.nav-menu {
		flex-grow: 1;
	}

	/* 主菜单样式 */
	.main-menu {
		display: flex;
		list-style: none;
		margin: 0;
		padding: 0;
		height: 100%;
		align-items: center;
		cursor: pointer;
	}

	.main-menu>li {
		position: relative;
		margin-right: 30px;
		height: 100%;
		display: flex;
		align-items: center;
	}

	.main-menu>li>a,
	.main-menu>li>router-link {
		color: #C4CFDE;
		text-decoration: none;
		font-size: 18px;
		/* padding: 10px 15px; */
		display: flex;
		align-items: center;
		height: 100%;
		position: relative;
	}

	/* 活动状态下的白线 */
	.active-line {
		position: absolute;
		bottom: -3px;
		left: 0;
		width: 100%;
		height: 3px;
		background-color: white;
		display: none;
	}

	/* 默认选中首页和活动状态 */
	.main-menu>li.active .active-line,
	.main-menu>li.router-link-exact-active .active-line,
	.main-menu>li.router-link-active .active-line {
		display: block;
	}

	.main-menu>li.active>a,
	.main-menu>li.active>router-link,
	.main-menu>li.router-link-exact-active>a,
	.main-menu>li.router-link-active>a {
		color: white;
	}

	/* 下拉菜单样式 */
	.submenu {
		position: absolute;
		top: 100%;
		left: 0;
		background-color: white;
		min-width: 200px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		list-style: none;
		padding: 10px 0;
		margin: 0;
		z-index: 100;
	}

	.submenu a {
		color: #333 !important;
		padding: 8px 20px;
		display: block;
		text-decoration: none;
	}

	.submenu a:hover {
		background-color: #f5f5f5;
	}

	/* 三级菜单样式 */
	.third-menu {
		position: absolute;
		left: 100%;
		background-color: white;
		min-width: 200px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		list-style: none;
		padding: 10px 0;
		margin: 0;
		display: none;
	}

	.has-submenu:hover .third-menu {
		display: block;
	}

	/* 悬停效果 */
	.has-submenu:hover .submenu {
		display: block;
	}

	.disabled-menu-item {
		cursor: default;
		opacity: 0.6;
	}

	.disabled-link {
		color: #999 !important;
		text-decoration: none !important;
		pointer-events: none;
		cursor: default;
	}
	.display-none{
		display: none !important;
	}
	
	
	
	/* 右上角登录注册容器 */
	.top-right-auth {
	  position: absolute;
	  top: 20px; /* 垂直间距 */
	  right: 30px; /* 水平间距 */
	  display: flex;
	  align-items: center;
	}
	
	.top-right-auth a {
	  color: #C4CFDE !important; /* 与导航文字同色 */
	  text-decoration: none;
	  font-size: 16px;
	  padding: 0 8px;
	  transition: color 0.3s;
	}
	
	.top-right-auth a:hover {
	  color: white !important; /* 悬停变白色 */
	}
	
	.auth-divider {
	  color: #C4CFDE;
	  padding: 0 2px;
	}
</style>